import { Component, Inject, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { PartnerCategory } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-entity';
import { SalesChannel } from 'src/app/assabil-kernel/models/entities/control-tables/sales-channel';
import { ItineraryLovComponent } from '../itinerary-lov/itinerary-lov.component';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { PartnerPipe } from 'src/app/assabil-kernel/pipes/partner-pipe';

@Component({
    selector: 'partner-lov',
    templateUrl: './partner-lov.component.html',
    styleUrls: ['./partner-lov.component.scss']
})


export class PartnerLovComponent extends GenericLovComponent {
  
   
itineraryLovComponent = ItineraryLovComponent;
  //----------------------------------------------------------------------
  partnerPipe             : PartnerPipe = new PartnerPipe();
  //----------------------------------------------------------------------
  progressLevel         : any;

// ---------------------------------------------------
code                : string;
name                : string;

branchs             : Branch[];
partnerCategorys    : PartnerCategory[];
salesChannels       : SalesChannel[];

branchCode          : string;
itinerary           : Itinerary;
salesChannelCode    : string;
partnerCategoryCode : string;
partnerStatusCode   : string;

// ---------------------------------------------------



//----------------------------------------------------
partners          : Partner[] = [];
sourcePartners    : Partner[] = [];
selectedPartners  : Partner[] = [];
dual              : boolean = false;
returnList        : boolean = false;  
// ---------------------------------------------------


columns = [
    { prop: 'partnerCode',    name: 'Code'},
    { prop: 'name',           name: 'Name' }
]

constructor(
    public dialogRef: MatDialogRef<PartnerLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected userService       : UserService,
    protected router            : Router,
    protected location          : Location,
    protected controlService    : ControlTablesService) {
        super();
        if (data){
            this.partners  = data.partners;
            this.dual      = data.dual;
            this.returnList= data.returnList;
        }
    }
    
    
//---------------------------------------------------------------------------------------------------------------- 
ngOnInit() {
    super.ngOnInit();
    this.setData();

    this.controlService.getList("branch",           this.controlService.getRequest()).then(result => { 
        this.branchs = result;
    });

    this.controlService.getList("partnerCategory", this.controlService.getRequest()).then(result => { 
        this.partnerCategorys = result;
    });
    
    this.controlService.getList("salesChannel",   this.controlService.getRequest()).then(result => { 
        this.salesChannels = result;
    });
  
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
loadData() {
    let progressLevelId : number = null;
    if (this.progressLevel) progressLevelId = this.progressLevel.id;
    let itineraryCode : string = null;
    if (this.itinerary) itineraryCode = this.itinerary.itineraryCode;

    this.masterDataService.partnersGet(this.code, this.branchCode, itineraryCode, this.name, this.salesChannelCode, this.partnerCategoryCode, this.partnerStatusCode, progressLevelId, this.serverPageNumber).then(result => {
        this.partners = result.partners;
        if(this.serverPageNumber == 0){
            this.totalRowCount      = result.rowCount;
            this.serverPageCount    = result.serverPageCount;
        }
        this.setData();
    })
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
setData() {
    if (! this.partners ) return;
    this.sourcePartners  = [...this.partners];
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
addToSelected(partner : Partner){
    this.selectedPartners.push(partner);
    this.sourcePartners.splice(this.sourcePartners.indexOf(partner),1)
    this.sourcePartners   = [...this.sourcePartners]
    this.selectedPartners = [...this.selectedPartners]
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
removeFromSelected(partner : Partner){
    this.sourcePartners.push(partner);
    this.selectedPartners.splice(this.selectedPartners.indexOf(partner),1)
    this.sourcePartners     = [...this.sourcePartners]
    this.selectedPartners = [...this.selectedPartners]
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
addAll(){
    this.sourcePartners   = [];
    this.selectedPartners = [...this.partners];
}
removeAll(){
    this.sourcePartners   = [...this.partners];
    this.selectedPartners = [];
}
//----------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------
closeModal(partner : Partner){
    if (this.returnList || this.dual) {
        let result = {partners : null, partner : null, selectedPartners : null};
        result.partner             = partner;
        result.selectedPartners    = this.selectedPartners;
        result.partners            = this.partners;
        this.dialogRef.close(result);
    } else {
        this.dialogRef.close(partner);
    }
}
 //----------------------------------------------------------------------------------------------------------------

}


